import { render, staticRenderFns } from "./AccountExtraFeatures.vue?vue&type=template&id=b9ae8094&scoped=true&"
import script from "./AccountExtraFeatures.vue?vue&type=script&lang=js&"
export * from "./AccountExtraFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ae8094",
  null
  
)

export default component.exports